import { defineStore } from 'pinia'
import axios from 'axios';
export const useCartStore = defineStore('cart',{
  state: () => ({
    storageItem: [],
    quantityCart: 0,
    cartSize: 0,
    qtyCartItem: 0,
    total_price: 0,
    post_price: 0,
    quantityArray: [],
    activeBtn: false,
    refreshWatch: false,
    showCartMenu: true,
    changeFavorite: true,
    zeroCartId: false,
  }),
  getters: {
    getStorageSize: (state) => state.cartSize,
    getQuantityCart: (state) => state.quantityCart,
    getQtyCartItem: (state) => state.qtyCartItem,
    getCardItem: (state) => state.storageItem,
    getTotalPrice: (state) => state.total_price,
    getPostPrice: (state) => state.post_price,
    getQuantityArray: (state) => state.quantityArray,
    getZeroCartId: (state) => state.zeroCartId,
    getActiveBtn: (state) => state.activeBtn,
    getRefreshWatch: (state) => state.refreshWatch,
    getCartMenu: (state) => state.showCartMenu,
    getChangeFavorite: (state) => state.changeFavorite,
  },
  actions: {
    setStorage(info) {
      this.quantityCart = info.length;
      this.total_price = 0;
      this.post_price = 0;
      this.qtyCartItem = 0;
      this.storageItem = [];
      for (let i = 0; i < info.length; i++) {
        this.storageItem[i] = {
          id: info[i].id,
          product: {
            id: info[i].product.id,
            name: info[i].product.name,
            slug: info[i].product.slug,
            images: [
              {
                image: info[i].product.images[0].image,
                description: info[i].product.images.description,
              },
            ],
          },
          variation: {
            id: info[i].variation.id,
            product: info[i].variation.product,
            color: info[i].variation.color,
            size: info[i].variation.size,
            discounted_price: info[i].variation.discounted_price,
            price: info[i].variation.price,
            inventory: info[i].variation.inventory,
          },
          quantity: info[i].quantity,
          total_price: info[i].total_price,
          post_price: info[i].post_price,
        };

        this.total_price += info[i].total_price;
        this.post_price = info[i].post_price;
        this.qtyCartItem += info[i].quantity;
      }

        localStorage.setItem("cart_item", JSON.stringify(this.storageItem));
     
      if (info.length <= 0) {
        this.storageItem = info;

          localStorage.setItem("cart_item", JSON.stringify(this.storageItem));
   
      }

      this.cartSize = this.storageItem.length;
    },
    setZeroCartId() {
      this.zeroCartId = !this.zeroCartId;
    },
    reset() {
      this.qtyCartItem = 0;
      this.storageItem = [];
      this.cartSize = 0;
    },
    setQuantitiyArray_qtyCartItem() {
      this.quantityArray = [];
      this.qtyCartItem = 0;
    },

    setData() {
      this.qtyCartItem = 0;
      this.total_price = 0;
      if (JSON.parse(localStorage.getItem("cart_item"))) {
        let item = JSON.parse(localStorage.getItem("cart_item"));
        for (let i = 0; i < item.length; i++) {
          this.storageItem[i] = item[i];
          // set total_price
          this.total_price += item[i].total_price;
          this.qtyCartItem += item[i].quantity;
        }
        this.cartSize = item.length;
      } else {
        this.cartSize = 0;
      }
    },
    enableCardAddBtn() {
      this.activeBtn = true;
      console.log('enable')
    },
    disableCardAddBtn() {
      this.activeBtn = false;
    },
    async arrayQuantity() {
      try {
        let req = await axios.get(
          `https://parsinekala.com/backend/api/carts/${localStorage.getItem(
            "cart_id"
          )}/items/`
        );
        this.setStorage(req.data);
        this.setQuantityArray(req.data);

        // this.setTotalPrice();
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404 || e.response.status == 400 && e.response.data.detail == 'No cart with this id!') {
            try {
              let req = await axios.post("https://parsinekala.com/backend/api/carts/");
              let id = req.data.id;
                localStorage.setItem("cart_id", id);
                this.setQuantitiyArray_qtyCartItem();
                localStorage.removeItem('cartItem');
             
              this.setZeroCartId();
              this.setStorage(req.data);
              this.setQuantityArray(req.data);
              this.setTotalPrice();
            } catch (e) {
              // console.log(e);
            }
          }
        }
        // console.log(e)
      }
    },

    setTotalPrice() {
      this.total_price = 0;
      if (JSON.parse(localStorage.getItem("cart_item"))) {
        let item = JSON.parse(localStorage.getItem("cart_item"));
        for (let i = 0; i < item.length; i++) {
          this.total_price += item[i].total_price;
        }
      }
    },
    setQuantityArray(info) {
      this.quantityArray = []

      if (info) {
        for (let i = 0; i < info.length; i++) {
          this.quantityArray[i] = { id: info[i].id, qty: info[i].quantity, inventory: info[i].variation.inventory }

        }

      } else {
        this.quantityArray = []

      }
    },


    setRefreshWatch() {
      this.refreshWatch = !this.refreshWatch
    },
    reset() {
      this.qtyCartItem = 0;
      this.storageItem = [];
      this.cartSize = 0;
    },
    setCartMenuEnable() {
      this.showCartMenu = true
    },
    setCartMenuDisable() {
      this.showCartMenu = false
    },
    setChangeFavorite() {
      this.changeFavorite = !this.changeFavorite;
    }
  },
})
